import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-demo-seven',
  templateUrl: './home-demo-seven.component.html',
  styleUrls: ['./home-demo-seven.component.scss']
})
export class HomeDemoSevenComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
